var devisParamsBo = {
    categorie: ''
};

export default devisParamsBo;


// WEBPACK FOOTER //
// ./src/components/data/devis/DevisParams.js